import React from 'react';
import type {} from '@jobseeker/lotus/mui.types';
import {Box, Typography} from '@mui/material';
import {Paragraph} from '@jobseeker/lotus/elements';
import type {} from '@jobseeker/lotus/mui.types';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

const AboutIIMJobsSection = () => {
  const theme = useWrappedTheme();
  return (
    <Box
      id="about-iimjobs"
      sx={{
        width: {xs: '100%', md: '70%'},
        textAlign: 'center',
        margin: '0 auto',
        paddingTop: {xs: 10, md: 12},
        paddingBottom: 4,
      }}
    >
      <Typography
        variant="sectionMainHeading"
        sx={{fontSize: {xs: 22, md: 42}}}
      >
        About iimjobs
      </Typography>
      <Paragraph
        style={{
          textAlign: 'center',
          marginTop: 2,
          fontSize: {
            xs: theme.typography.pxToRem(14),
            md: theme.typography.pxToRem(16),
          },
          fontWeight: 300,
        }}
        title=""
        body={
          <>
            iimjobs.com is a job-site exclusively designed for premium
            management candidates, providing access to premium jobs from the
            biggest brands. Devoted to meeting the distinct needs of top-tier
            professionals, iimjobs.com connects you with exceptional career
            prospects that align with your expertise and ambitions.
            <br />
            <br />
            Our unwavering dedication to excellence guarantees that each
            interaction is tailored to your specific requirements, offering a
            confidential and professional space for your job search. Elevate
            your career to new horizons with iimjobs.com
          </>
        }
      />
    </Box>
  );
};

export default AboutIIMJobsSection;
